module.exports = __webpack_public_path__ + "static/media/warning.cca8ec08.svg";